import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { getIsNegativePromptInputVisible } from '../../../../redux/form/selectors';
import { toggleNegativePrompt } from '../../../../redux/form/actions';
import LabelText from '../LabelText';
import s from './NegativePromptToggle.scss';
const NegativePromptToggle = ({ size })=>{
    const { t } = useTranslation('dreamup');
    const labelId = useUniqueId();
    const dispatchToggleNegativePrompt = useAction(toggleNegativePrompt);
    const isNegativeInputPromptVisible = useSelector(getIsNegativePromptInputVisible);
    return /*#__PURE__*/ React.createElement("label", {
        id: labelId,
        className: s['root']
    }, /*#__PURE__*/ React.createElement(LabelText, null, t('dreamup.header.settingsPanel.negativePromptToggle.label')), /*#__PURE__*/ React.createElement(MainToggle, {
        variant: "dreamup-purple",
        value: isNegativeInputPromptVisible,
        onChange: dispatchToggleNegativePrompt,
        "aria-labelledby": labelId,
        size: size,
        type: "button"
    }));
};
NegativePromptToggle.displayName = 'NegativePromptToggle';
export default NegativePromptToggle;

//# sourceMappingURL=NegativePromptToggle.js.map